// src/common/api.js

export const BASE_URL = "/api"; // 🔥 ¡Necesario para que auth.js lo importe!

/**
 * apiFetch: envoltorio para fetch con token y headers por defecto
 * @param {string} endpoint - por ejemplo "/orders"
 * @param {object} options - opciones de fetch estándar
 */
export async function apiFetch(endpoint, options = {}) {
  const token = localStorage.getItem("token");

  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  };

  const res = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers
  });

  return res;
}
